import axios from 'axios'
import { host } from '../../configuraciones'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

const dataInicial = {
    Superficie: []
}

//DEFINICIÓN DE MÉTODOS *********************************************************************************************
const GET_ALL_SUPERFICIES = 'GET_ALL_SUPERFICIES'
const GET_SUPERFICIE_BY_ID = 'GET_SUPERFICIE_BY_ID'
const GET_SUPERFICIE_BY_ID_ANEXO = 'GET_SUPERFICIE_BY_ID_ANEXO'
const POST_SUPERFICIE = 'POST_SUPERFICIE'
const UPDATE_SUPERFICIE = 'UPDATE_SUPERFICIE'
const DELETE_SUPERFICIE = 'DELETE_SUPERFICIE'
//*******************************************************************************************************************


//MÉTODOS 
export const getAllSuperficies = createAsyncThunk(
    GET_ALL_SUPERFICIES,
    async () => {
        try {
            const fullUrl = host + `Superficie/obtenerSuperficies`
            const res = await axios.get(fullUrl)
            //console.log('Se obtienen las Superficies: '+JSON.stringify(res.data))
            return res
        } catch (error) {
            console.log(error.res);
        }
    }
)

export const getSuperficieById = createAsyncThunk(
    GET_SUPERFICIE_BY_ID,
    async (idSuperficie) => {
        try {
            const fullUrl = host + `Superficie/obtenerSuperficieById/${idSuperficie}`
            const res = await axios.get(fullUrl)
            //console.log('Se obtienen los Coches: '+JSON.stringify(res))
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

export const getSuperficieByIdInforme = createAsyncThunk(
    GET_SUPERFICIE_BY_ID_ANEXO,
    async (idAnexo) => {
        try {
            const fullUrl = host + `Superficie/obtenerSuperficieByIdanexo/${idAnexo}`
            const res = await axios.get(fullUrl)
            //console.log('Se obtienen los Coches: '+JSON.stringify(res))
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

export const insertSuperficie = createAsyncThunk(
    POST_SUPERFICIE,
    async (data) => {
        try {
            const fullUrl = host + `Superficie/agregarSuperficie`
            //alert(JSON.stringify(data))
            const result = await axios.post(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

export const updateSuperficie = createAsyncThunk(
    UPDATE_SUPERFICIE,
    async (data) => {
        try {
            const fullUrl = host + `Superficie/actualizarSuperficie`
            //alert(JSON.stringify(data))
            const result = await axios.put(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

export const deleteSuperficie = createAsyncThunk(
    DELETE_SUPERFICIE,
    async (idSuperficie) => {
        try {
            const fullUrl = host + `Superficie/eliminarSuperficie/${idSuperficie}`
            const result = await axios.delete(fullUrl)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

//****************************************************************************************************************
//EXPORTS DE MÉTODOS
export const metodosSuperficieSlice = createSlice({

    name: 'metodosSuperficieSlice',
    initialState: dataInicial,
    reducers: {
    },
    extraReducers: {

        [getAllSuperficies.fulfilled]: (state, { payload }) => {
            //console.log('PAYLOAD VEHICULOS'+JSON.stringify(payload))
            state.Superficie = payload.data.data

        },
        [getSuperficieById.fulfilled]: (state, { payload }) => {
            //console.log('PAYLOAD COCHES'+JSON.stringify(payload))
            state.Superficie = payload.data.data
        },
        [getSuperficieById.fulfilled]: (state, { payload }) => {
            //console.log('PAYLOAD COCHES'+JSON.stringify(payload))
            state.Superficie = payload.data.data
        },
        [insertSuperficie.fulfilled]: (state, { payload }) => {
            state.Superficie = payload.data.data
        },

        [updateSuperficie.fulfilled]: (state, { payload }) => {

        },
        [deleteSuperficie.fulfilled]: (state, { payload }) => {

        },

    },

})


export const { } = metodosSuperficieSlice.actions
export const SuperficieReducer = metodosSuperficieSlice.reducer